import { render, staticRenderFns } from "./Gravatar.vue?vue&type=template&id=1fbc4df3&scoped=true"
import script from "./Gravatar.vue?vue&type=script&lang=js"
export * from "./Gravatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc4df3",
  null
  
)

export default component.exports